import { selectDocumentById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { modelIconNameMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { DEFAULT_MAX_ICONS } from "./constants"
import { LuDynamicIconWithWrapper, type LuDynamicIconWithWrapperProps } from "./LuDynamicIconWithWrapper"
import type { IconsProps, IconType } from "./typings"

interface DocumentIconProps extends Omit<LuDynamicIconWithWrapperProps, "color" | "icon" | "fallback"> {
	documentId: string
}

export const DocumentIcon = memo<DocumentIconProps>((props) => {
	const { ref, documentId, background = true, ...rest } = props

	const document = useAppSelector(selectDocumentById(documentId))

	return (
		<LuDynamicIconWithWrapper
			ref={ref}
			color={document?.color}
			icon={(document?.icon ?? modelIconNameMapping.document) as IconType}
			background={background}
			{...rest}
		/>
	)
})
DocumentIcon.displayName = "DocumentIcon"

interface DocumentIconsProps extends IconsProps {
	documentIds: string[]
}

export const DocumentIcons = memo<DocumentIconsProps>((props) => {
	const { ref, className, documentIds, max = DEFAULT_MAX_ICONS, ...rest } = props

	return (
		<span ref={ref} className={cx("flex -space-x-2", className)} {...rest}>
			{documentIds.slice(0, max ?? documentIds.length).map((documentId) => (
				<DocumentIcon documentId={documentId} key={documentId} />
			))}
		</span>
	)
})
DocumentIcons.displayName = "DocumentIcons"
